import { render, staticRenderFns } from "./StyleDialog.vue?vue&type=template&id=1c054fc6&scoped=true&"
import script from "./StyleDialog.vue?vue&type=script&lang=js&"
export * from "./StyleDialog.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialog.vue?vue&type=style&index=0&id=1c054fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c054fc6",
  null
  
)

export default component.exports